import React, { Fragment, useEffect } from 'react'
import { StepperShell } from '../../components/_WMS/Stepper'
import { RelocateState } from './types'
import { SkuAndBrandStep } from './steps/SkuAndBrandStep'
import { PositionsStep } from './steps/PositionsStep'
import { ConfirmationStep } from './steps/ConfirmationStep'
import { useProductOrigins } from '../../hooks'

const NewRelocatePage: React.FC = () => {
  const initialSharedState: RelocateState = {
    // Datos del producto
    sku: '',
    productOriginId: null,
    productOriginName: '',
    isGreenSale: false,
    
    // Posiciones
    posicionOrigen: '',
    cantidad: null,
    posicionDestino: '',
    availableStock: undefined,
    originPositionId: undefined,
    destinyPositionId: undefined,
    stockKeepingUnitId: undefined,
    
    // Manejo de merma
    isDamaged: false,
    originPositionType: undefined,
    originZone: undefined,

    // Posiciones sugeridas
    availablePositions: undefined,
    suggestedPositions: undefined,
    
    // Manejo de lotes/fechas de expiración
    hasBatchManagement: false,
    hasExpirationDate: false,
    selectedBatch: undefined,
    availableBatches: undefined,
    showBatchModal: false,
    expirationDays: 0,
    
    // Comentarios y documentos
    documentNumber: undefined,
    observations: undefined,
    requiresComments: false,
    
    // Estados
    error: undefined,
    isLoading: false
  }

  const { getProductOrigins } = useProductOrigins()

  useEffect(() => {
    // Cargar marcas al inicializar la página
    getProductOrigins()
  }, [])

  return (
    <Fragment>
      <StepperShell<RelocateState>
        steps={[
          (props) => <SkuAndBrandStep {...props} />,
          (props) => <PositionsStep {...props} />,
          (props) => <ConfirmationStep {...props} />
        ]}
        initialSharedState={initialSharedState}
      />
    </Fragment>
  )
}

export default NewRelocatePage